module.exports = __webpack_public_path__ + "agendaI.png";